import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { ITest } from "src/Interfaces/TestInterface";
import { IWell, IWellCloseReview } from "src/Interfaces/WellInterface";
import PdfService from "src/Services/Pdf";
import TenantStore from "src/Stores/Tenant/TenantStore";
import { TestsStore } from "src/Stores/Tests/TestsStore";
import { UserStore } from "src/Stores/User/UserStore";
import { WellsStore } from "src/Stores/Wells/WellsStore";

@inject('stores')
@observer
export default class VolumeAccountingReportPdf extends React.Component {
    public props: any;
    private test: ITest;
    public TestsStore: TestsStore;
    private well: IWell;
    public WellsStore: WellsStore;
    public UserStore: UserStore;
    public TenantStore: TenantStore;
    
    public state = {
        test: this.test,
        tests: [] as ITest[],
        well: this.well,
        wellCloseReview: undefined as IWellCloseReview | undefined,
    };

    constructor(props: any) {
        super(props);

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;
        this.UserStore = this.props.stores.UserStore;
        this.TenantStore = this.props.stores.TenantStore;
    }

    public componentDidMount() {
        this.getAllTestsData();
        this.getWellData();
        if (!this.UserStore.user) {
            this.UserStore.getProfile();
        }
    }

    public componentDidUpdate() {
        this.renderIframe();
    }

    private renderIframe() {
        const myFrame: any = document.getElementById('my_frame');
        if (myFrame) {
            this.pdfReportString().then((data: any) =>
                myFrame.src = data
            );
        }
    }

    private getAllTestsData() {
        return this.TestsStore.getAllTestsDetailsReport(this.props.match.params.wellId)
        .then(
            (data: any) => {
                this.setState({
                    tests: data,
                });
            }
        );
    }

    private getWellData() {
        return this.WellsStore.getWellReport(this.props.match.params.wellId)
        .then(
            (data: any) => {
                if(data.wellStatus !== 'Active') {
                    return this.WellsStore.getWellCloseReview()
                        .then(dataWCR => {
                            this.setState({well: data, wellCloseReview: dataWCR});
                        });
                }
                else {
                    this.setState({
                        well: data
                    });
                    return data;
                }
            }
        );
    }

    private pdfReportString = () => {
        let filteredList;
        if ( this.props.match.params.taskId ) {
            const lastTest = this.state.tests.find(wt => wt.id === this.props.match.params.taskId);
            if (lastTest) {
                filteredList = this.state.tests.filter(wt => Number(wt.testDate) <= Number(lastTest.testDate));
            }
        }
        if (filteredList) {
            return PdfService.createVolumePdf(filteredList, this.state.well, this.state.wellCloseReview, this.TenantStore.logoPathNameReport);
        }
        return PdfService.createVolumePdf(this.state.tests, this.state.well, this.state.wellCloseReview, this.TenantStore.logoPathNameReport);
    }

    public render() {
        if ((this.state.tests.length === 0 ) || this.state.well === undefined || (this.state.well.wellStatus !== 'Active' && this.state.wellCloseReview === undefined)) {
            return (
                <FontAwesomeIcon 
                icon={faSpinner}
                spin={true}
                size={"8x"}
                style={{position: 'fixed', left: '50%', top: '35%'}}
            />
            );
        }
        return (
            <iframe id="my_frame" style={{width: '100%', height: '2000px'}} />
        );
    }


}


// WEBPACK FOOTER //
// ./src/Components/Reporting/VolumeAccountingReportPdf.tsx